<div class="ir-item-line th-filter" *ngIf="actionPlanItems?.length">
  <div (click)="setOrderBy('name')" class="ir-item-cell s1 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'actionplans.actionplanitem.points' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('observation')" class="ir-item-cell s3 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'actionplans.actionplanitem.observations' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('recommandation')" class="ir-item-cell s3 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'actionplans.actionplanitem.recommendations' | translate }}
    </span>
  </div>
  <div class="ir-item-cell s2">
    <span>
      {{ 'actionplans.actionplanitem.impacts' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('status')" class="ir-item-cell s1 clickable right">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      Status
    </span>
  </div>
</div>
<div class="ir-content-flow" [ngClass]="actionPlanItems?.length ? 'has-filter' : ''">
  <div *ngIf="actionPlanItems">
    <div
      class="ir-item-line th-section clickable"
      (click)="openActionPlanItem(item)"
      *ngFor="let item of actionPlanItems | orderBy: orderByFieldName:direction | searchBy: query"
    >
      <div class="ir-item-cell s1">
        <span class="noellipsis" innerHtml="{{ item.point?.name }}"></span>
      </div>
      <div class="ir-item-cell s3">
        <span
          class="noellipsis"
          *ngIf="item.observation?.indexOf('plugins.') == 0"
          innerHtml="{{ item.observation | translate }}"
        ></span>
        <span
          class="noellipsis"
          *ngIf="item.observation?.indexOf('plugins.') != 0"
          innerHtml="{{ item.observation }}"
        ></span>
      </div>
      <div class="ir-item-cell s3">
        <span
          class="noellipsis"
          *ngIf="item.recommandation?.indexOf('plugins.') == 0"
          innerHtml="{{ item.recommandation | translate }}"
        ></span>
        <span
          class="noellipsis"
          *ngIf="item.recommandation?.indexOf('plugins.') != 0"
          innerHtml="{{ item.recommandation }}"
        ></span>
      </div>
      <div class="ir-item-cell s2">
        <table>
          <ng-container *ngFor="let i of item.impacts | keyvalue">
            <tr *ngIf="i.value.enabled">
              <td>
                <span
                  ><strong class="important"
                    >{{ 'plugins.observation.value.' + i.value.id + '.title' | translate }} </strong
                  ><strong class="important"> - {{ i.value.text }} </strong>
                  {{ 'plugins.observation.value.' + i.value.id + '.boost' | translate }}</span
                >
              </td>
            </tr>
          </ng-container>
        </table>
      </div>
      <div class="ir-item-cell s1 right statut">
        <i *ngFor="let icon of item.icons" class="material-icons {{ icon.classes }}">{{
          icon.count !== 0 ? icon.name : ''
        }}</i>
        <span>{{ item.status | actionPlanItemStatus }}</span>
      </div>
    </div>
  </div>
  <div class="ir-item-empty ir-mv8" *ngIf="actionPlanItems?.length == 0">
    <p>
      <span>No items</span>
    </p>
  </div>
</div>
